var map = {
	"./1_FeliErnst_fotografía_Edding38.webp": "./src/img/brands/edding/1_FeliErnst_fotografía_Edding38.webp",
	"./FeliErnst_fotografía_Edding21.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding21.webp",
	"./FeliErnst_fotografía_Edding22.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding22.webp",
	"./FeliErnst_fotografía_Edding3.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding3.webp",
	"./FeliErnst_fotografía_Edding40.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding40.webp",
	"./FeliErnst_fotografía_Edding52.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding52.webp",
	"./FeliErnst_fotografía_Edding53.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding53.webp",
	"./FeliErnst_fotografía_Edding63.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding63.webp",
	"./FeliErnst_fotografía_Edding74.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding74.webp",
	"./FeliErnst_fotografía_Edding_U0A0432.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A0432.webp",
	"./FeliErnst_fotografía_Edding_U0A0471.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A0471.webp",
	"./FeliErnst_fotografía_Edding_U0A0472.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A0472.webp",
	"./FeliErnst_fotografía_Edding_U0A0486.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A0486.webp",
	"./FeliErnst_fotografía_Edding_U0A9566.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A9566.webp",
	"./FeliErnst_fotografía_Edding_U0A9942.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A9942.webp",
	"./FeliErnst_fotografía_Edding_U0A9962.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A9962.webp",
	"./FeliErnst_fotografía_Edding_U0A9982.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A9982.webp",
	"./FeliErnst_fotografía_Edding_U0A9997.webp": "./src/img/brands/edding/FeliErnst_fotografía_Edding_U0A9997.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/edding sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";